const config = {
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  graphql: {
    serverUrl: process.env.REACT_APP_GRAPHQL_SERVER,
  },
  version: '0.5.16',
  appMode: process.env.REACT_APP_APP_MODE,
  satellites: {
    maxRateDiff: +(process.env.REACT_APP_MAX_SATELLITE_RATE_DIFF || 5),
  },
};

export default config;
